import { ButtonHTMLAttributes, ReactNode } from "react";
import { renderToString } from "../converter/renderToString";

type TProps = {
  body: (
    confirmButtonProps: Omit<
      ButtonHTMLAttributes<HTMLButtonElement>,
      "className"
    >,
    cancelButtonProps: Omit<
      ButtonHTMLAttributes<HTMLButtonElement>,
      "className"
    >,
  ) => ReactNode;
};

async function cietyConfirm({ body }: TProps) {
  const _body = await renderToString(
    body({ id: "confirm-button" }, { id: "cancel-button" }),
  );

  return new Promise<boolean>((resolve) => {
    const html = `
      <div class="twp modal-container">
       ${_body}
      </div>`;

    const wrapper = document.createElement("div");
    wrapper.innerHTML = html;
    const confirmContainerNode = wrapper.children[0];

    const closeModal = () => {
      document.querySelector("html")?.classList.remove("overflow-hidden");
      document.removeEventListener("keydown", handleKeyDown);
      document.body.removeChild(confirmContainerNode);
    };

    const handleKeyDown = (event: KeyboardEvent) => {
      if (event.key === "Enter" || event.key === "Escape") {
        event.preventDefault();
        closeModal();
        if (event.key === "Enter") {
          resolve(true);
        } else {
          resolve(false);
        }
      }
    };

    wrapper.querySelector("#confirm-button")?.addEventListener("click", () => {
      closeModal();
      resolve(true);
    });
    wrapper.querySelector("#cancel-button")?.addEventListener("click", () => {
      closeModal();
      resolve(false);
    });

    document.addEventListener("keydown", handleKeyDown);
    document.querySelector("html")?.classList.add("overflow-hidden");
    document.body.appendChild(confirmContainerNode);
  });
}

export { cietyConfirm };
